import { FavouriteMealRequest } from "@/clients/models/FavouriteMealRequest";
import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useAddFavouriteMeal = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [QueryKeys.FAVORITE_MEALS],
    mutationFn: async (requestBody: FavouriteMealRequest) => {
      const user = guardGetUserFromLocalStorage();
      return MealsService.addFavouriteMealApiV1MealsFavouritesPost(user.id, requestBody);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.FAVORITE_MEALS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.MY_FOODS] });
    },
  });

  return {
    addFavouriteMeal: mutation.mutate,
    addFavouriteMealAsync: mutation.mutateAsync,
    isAddingFavouriteMeal: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    response: mutation.data,
  };
};
